import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-picture_fill",
  "use": "icon-picture_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-picture_fill\"><path d=\"M799.936 721.984V800l-407.648 0.16 0.064-0.032-90.496 0.032 0.96-0.96 332.448-317.952 164.704 150.24v90.496zM416 320c52.96 0 96 43.072 96 96s-43.04 96-96 96c-52.928 0-96-43.072-96-96s43.072-96 96-96zM800.32 160H223.744A63.776 63.776 0 0 0 160 223.744v576.512C160 835.392 188.576 864 223.744 864H800.32A63.84 63.84 0 0 0 864 800.256V223.744A63.808 63.808 0 0 0 800.32 160z\" p-id=\"3765\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol